import { cn, putComma } from "@/lib/utils";

const ltpClosePrice = (ltp, close, quantity) => {
    return (ltp - close) * quantity;
};

export default function ProfitOrLoss({ nseLtpPrice, nseClosePrice, quantity, textClass }) {
    return (
        <div
            className={cn(
                `font-Inter ${
                    ltpClosePrice(nseLtpPrice, nseClosePrice, quantity) >= 0 ? "text-[#26A649]" : "text-[#EB4E2C]"
                }`,
                textClass
            )}
        >
            {putComma(ltpClosePrice(nseLtpPrice, nseClosePrice, quantity))} (
            {putComma(
                nseClosePrice ? Math.abs((ltpClosePrice(nseLtpPrice, nseClosePrice, 1) * 100) / nseClosePrice) : 0
            )}
            %)
        </div>
    );
}
